import React from 'react';
import styled from 'styled-components';

const HeroStyle = styled.div`
	background-color: ${(p) => p.theme.color.dark};
	padding-top: 2rem;
	img {
		width: 100%;
		display: block;
		&.mobile {
			display: none;
		}
	}
	.text-container {
		position: absolute;
		right: 10rem;
		top: 12rem;
		width: 18rem;
		color: #fff;
		text-align: right;
		h1 {
			font-size: 3.5rem;
			line-height: 3.5rem;
			@media all and (min-width: 669px) {
				&.break {
					float: right;
					/* Break on Every word */
					width: min-intrinsic;
					width: min-content;
					display: table-caption;
					display: -ms-grid;
					-ms-grid-columns: min-content;
				}
			}
		}
		h2 {
			font-size: 3.5rem;
			line-height: 3.5rem;
			color: ${(p) => p.theme.color.green};
		}
		p {
			margin-top: 1.5rem;
			font-size: 1.4rem;
			line-height: 1.7rem;
		}
	}

	&.events .text-container {
		width: 19rem;
	}
	@media all and (min-width: 1300px) {
		.text-container {
			right: 12rem;
			top: 15rem;
			width: 21rem;
			h1,
			h2 {
				font-size: 4rem;
				line-height: 4rem;
			}
			p {
				font-size: 1.7rem;
				line-height: 2rem;
			}
		}
		&.events .text-container {
			width: 25rem;
			h1.break {
				float: none;
				width: unset;
				display: block;
			}
		}
	}
	@media all and (min-width: 1600px) {
		.text-container {
			right: 20rem;
			top: 15rem;
			width: 30rem;
			h1,
			h2 {
				font-size: 5rem;
				line-height: 5rem;
			}
			p {
				font-size: 2.5rem;
				line-height: 3rem;
			}
		}
		&.events .text-container {
			width: 35rem;
			right: 15rem;
		}
	}

	@media all and (max-width: 900px) {
		.text-container {
			top: 10rem;
			right: 4rem;
		}
	}
	@media all and (max-width: 768px) {
		&.text .text-container {
			top: 8rem;
		}
	}
	@media all and (max-width: 668px) {
		.text-container {
			top: 6.5rem;
			right: 0;
			text-align: center;
			width: 100%;
			padding: 0 2rem;
			p {
				max-width: 400px;
				margin: 1.5rem auto 0;
			}
		}

		&.contact {
			padding-top: 6rem;
		}
		&.text {
			padding-top: 10rem;
			.text-container {
				top: 8rem;
				width: 100%;
			}
			img {
				margin-top: 0rem;
				&.desktop {
					display: none;
				}
				&.mobile {
					display: block;
				}
			}
		}
	}
	@media all and (max-width: 550px) {
		display: flex;
		flex-direction: column-reverse;
		padding-top: 2rem;
		&.text,
		&.contact {
			padding-top: 2rem;
		}
		.text-container {
			position: inherit;
			text-align: center;
			width: 100%;
			padding: 0 2rem;
		}
		img {
			margin-top: 0rem;
			&.desktop {
				display: none;
			}
			&.mobile {
				display: block;
			}
		}
	}
`;
export default ({
	img,
	mobileImg,
	alt,
	title,
	greenTitle,
	subtext,
	className,
}) => (
	<HeroStyle className={className}>
		{mobileImg && <img className="mobile" src={mobileImg} alt={alt} />}
		<img className={mobileImg ? 'desktop' : ''} src={img} alt={alt} />
		{title && (
			<div className="text-container">
				<h1 className={greenTitle ? 'break' : ''}>{title}</h1>
				{greenTitle && <h2>{greenTitle}</h2>}
				<p>{subtext}</p>
			</div>
		)}
	</HeroStyle>
);
